var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 39,
    y: 39,
    width: 39,
    height: 39,
    transform: "rotate(-180 39 39)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_1299",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_1299",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACDElEQVR4nO3dP2pUcRRH8RMTVCyEgI1gH4KljSmsBXULWrkG4wK0UqMrsIqVtRbuIE26NBY2ChYa/FOIAYexCDbiCPfBfC+/cD7w6rlchpl33ryZAUmSJEkSAGeAHeAzMF9wvAceAGtNM54IOyxe8N/HbtOMJ8L/nsn/OrZ7xhxfddEz4EbLpIN7Sm3Rc+ArsNkx7MjOAnvUl/0OuNAw79AuAh+oL/sNnomUXQF+UF/2k45hR3eb+qLnwN2OYUdXOa/+cxwB1zqGHdkq8Ir6sj8ClxrmHdp54ID6sveBcw3zDm0D+EJ92S+BlYZ5h3Yd+EV92Wb6BNvUFz0DbnUMO7rn1Jf9HbjcMezIzPQgMz3ITA8y04PM9BAzPchMDzLTg8z0IDM9yEwPMdODzPSgq8BP6ss20ycw04PM9BAzPWgdeEt92Wb6BJsc331aXfajjmFHNyXTPy17qFPLfoBBzLoHGI0vHQG+GQZ4ehcy5bsxBkvRHUzwpdvCi0pL52XSAC/8B6wAL6gv2Y+yiu5TX7IfzhZNvd3gXsewo9pgWl57A02BeR2wCrymvmTzusi8DjCvA8zrAPM6wLwOMK9DzOsA8zrAvA4wrwPM6xDzOsC8DjCvA8zrAPM65Bn1JX/DnzUuO6S25Blws2XSwfnT8yHVP1Mwryc6DTzm+DsjixZ8CDzEMwxJkiRJyvgNFuS6cSI2G6sAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/left-chevron.170e0f79398b767018d5ce0c4993264f.svg";
export { ForwardRef as ReactComponent };